// SERVICES
import { 
  postTrackerCount,
  postTrackerGroup, 
  postTrackerList, 
  postTrackerStates, 
} from 'services/tracker'

// UTILITIES
import { fetchApi } from 'utilities/api'

export const getCombinedTrackerData = async (
  email, 
  inputBodyParams, 
  isWithStates = false,
  primaryColor = '#000000',
  setIsLoading,
  auth, setAuth,
) => {
  try {
    setIsLoading(true)

    const resTrackers = await fetchApi(
      email,
      postTrackerList, 
      {}, 
      inputBodyParams, 
      auth, setAuth,
    )
    
    if (resTrackers?.data?.success) {
      const { list: trackers } = resTrackers?.data
      const { list: resGroups } = (await fetchApi(
        email,
        postTrackerGroup, 
        {}, 
        inputBodyParams, 
        auth, setAuth,
      ))?.data
      const groups = resGroups.reduce((obj, item) => Object.assign(obj, { [item.id]: {...item} }), {})
  
      const unblockedTrackers = trackers.filter(item => !item.source?.blocked).map(item => item.id)
      
      const { states } = isWithStates ? (
        await fetchApi(
          email,
          postTrackerStates, 
          {}, 
          {
            ...inputBodyParams,
            trackers: unblockedTrackers,
          }, 
          auth, setAuth,
        )
      )?.data : {
        states: null
      }

      const { value: odometer } = isWithStates ? (
        await fetchApi(
          email,
          postTrackerCount, 
          {}, 
          {
            ...inputBodyParams,
            trackers: unblockedTrackers,
            type: 'odometer',
          }, 
          auth, setAuth,
        )
      )?.data : {
        odometer: null
      }
  
      const { value: engineHours } = isWithStates ? (
        await fetchApi(
          email,
          postTrackerCount, 
          {}, 
          {
            ...inputBodyParams,
            trackers: unblockedTrackers,
            type: 'engine_hours',
          }, 
          auth, setAuth,
        )
      )?.data : {
        engineHours: null
      }
  
      setIsLoading(false)
  
      const newTrackerList = trackers.map((value) => ({
        ...value,
        state: states ? states[value.id] : null,
        group: value?.group_id !== 0 ? groups[value.group_id] : {
          color: primaryColor,
          title: 'Main Group',
          id: 0
        },
        odometer: odometer?.[value.id],
        engine_hours: engineHours?.[value.id],
      }))
    
      return newTrackerList
    } else {
      setIsLoading(false)
      return {
        status: 'failed'
      }
    }
  }
  catch (error) {
    setIsLoading(false)

    if (error.message === 'canceled') return { status: 'Canceled' }
    else if (!error.response) return { status: 'No Server Response' }
    else return error.response
  }
}